/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_4ed831f3","_4ed831f3",""]'><div :class='["","_4ed831f3",""]'><cube-button @_click="showPicker" :class='["","_4ed831f3",""]'>basic-picker</cube-button><cube-date-picker-popup ref="__mpx_ref_picker__" title="日期选择器" sub-title="请选择具体的时间" cancel-txt="返回" confirm-txt="确定" :columnCount="(4)" :min="(min)" :max="(max)" :value="(value)" @toggle='(e)=>__invoke(e, [["onToggle"]])' @close='(e)=>__invoke(e, [["onClose"]])' @change='(e)=>__invoke(e, [["onChange"]])' @columnChange='(e)=>__invoke(e, [["onColumnChange"]])' @confirm='(e)=>__invoke(e, [["onConfirm"]])' @valueChange='(e)=>__invoke(e, [["onValueChange"]])' :class='["","_4ed831f3",""]'/><div :class='["demo-data","_4ed831f3",""]' v-if="(confirmParams.length || valueChangeParams.length)"><div :class='["key","_4ed831f3",""]'>其他事件可打开控制台查看输出</div><template v-if="(confirmParams.length)"><div :class='["key","_4ed831f3",""]'>confirmParams 事件参数：</div><div :class='["value","_4ed831f3",""]'><div v-for="(item, index) in (confirmParams)" :key="item.index" :class='["value-item","_4ed831f3",""]'><div :class='["item-key","_4ed831f3",""]'>{{item[0]}}</div><div :class='["item-value","_4ed831f3",""]'>{{item[1]}}</div></div></div></template><template v-if="(valueChangeParams.length)"><div :class='["key","_4ed831f3",""]'>valueChange 事件触发次数：{{ valueChangeCount }}</div><div :class='["key","_4ed831f3",""]'>valueChangeParams 事件参数：</div><div :class='["value","_4ed831f3",""]'><div v-for="(item, index) in (valueChangeParams)" :key="item.index" :class='["value-item","_4ed831f3",""]'><div :class='["item-key","_4ed831f3",""]'>{{item[0]}}</div><div :class='["item-value","_4ed831f3",""]'>{{item[1]}}</div></div></div></template></div></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"scoped":true,"mid":"_4ed831f3"}'>
.event-params,
.demo-data
  margin-top: 10px
  padding: 10px 10px
  background-color: white
  border: 1px solid  white
  border-radius: 10px

.key
  margin-bottom: 10px
  font-size: 16px
.key-introduce
  margin-bottom: 10px
  line-height: 20px
.value
  margin-bottom: 20px
  white-space: break-spaces
  .value-item
    display flex
    justify-content: space-between
    height: 25px
    line-height: 25px
    font-size: 15px
    .item-value
      white-space nowrap
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_4ed831f3"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_4ed831f3"}
  /** script content **/
  require("./basic-picker.mpx.js?isComponent&outputPath=components%2Fbasic-picker4ed831f3%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./basic-picker.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbasic-picker4ed831f3%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_4ed831f3"],
    ctorType: "component",
    outputPath: "components/basic-picker4ed831f3/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-date-picker-popup':getComponent(require("../../../packages/mpx-cube-ui/src/components/date-picker-popup/index.mpx?isComponent&outputPath=components%2Findex012972d9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>